/** Estimate drive time between two points using Haversine distance.
 * Returns minutes. Assumes ~2 min/km urban average.
 *
 * Body byte-equivalent to mobile crewbit-mobile/utils/driveTime.ts modulo runtime
 * per feedback_admin_pair_must_match_mobile_body.md. Foundation v1 D14 substrate
 * gap closed at C4 §0 pre-flight (admin pair authored alongside mobile import).
 *
 * TODO: Replace with Google Directions API for exact times (matches mobile TODO). */
export function estimateDriveMinutes(
  lat1: number, lng1: number,
  lat2: number, lng2: number,
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  const km = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.max(1, Math.ceil(km * 2));
}

/** Distance in km between two points (Haversine). Sister helper for route summary "X km" labels. */
export function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
